import { Link, matchPath, useLocation } from 'react-router-dom';
import { Item, ItemText } from 'components/layout/navbar/navbar-panel.utils';
import { useCloseOnMobile } from 'components/layout/navbar/navbar-panel.hooks';
import { castPath } from 'utils/router.utils';
import isFunction from 'lodash/isFunction';
import { type ReactNode } from 'react';
import Tooltip from 'components/common/tooltip';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';

export interface MenuItem {
  key: string;
  title: ReactNode;
  to: string | (() => string);
  icon: ReactNode;
  exact?: boolean;
  onClick?: () => void;
  isAuthorized?: boolean;
}
interface NavbarMenuItemProps {
  item: MenuItem;
}

const NavbarMenuItem = ({ item }: NavbarMenuItemProps) => {
  const { isCollapsed } = useNavbarCollapse();
  const location = useLocation();
  const closeOnMobile = useCloseOnMobile();

  const toPath = isFunction(item.to) ? item.to() : item.to;
  const isActive = Boolean(matchPath(castPath(toPath, item.exact), location.pathname));

  const handleClick = () => {
    closeOnMobile();
  };

  const itemElement = (
    <Item onClick={handleClick} data-e2e={item.key} active={isActive}>
      <>
        {item.icon}
        {!isCollapsed && <ItemText>{item.title}</ItemText>}
      </>
    </Item>
  );

  const itemContent =
    isCollapsed && item.title ? (
      <Tooltip title={item.title} placement="right">
        {itemElement}
      </Tooltip>
    ) : (
      itemElement
    );

  return (
    <Link key={item.key} to={toPath}>
      {itemContent}
    </Link>
  );
};

export default NavbarMenuItem;
